<template>
  <re-page
    background
    max-width="full"
  >
    <SupportInbox v-if="userIs.support" />
    <RegularInbox v-else />
  </re-page>
</template>

<script setup>
import { useCurUser } from '@/composables/useCurUser'

import RegularInbox from './regularInbox.vue'
import SupportInbox from './supportInbox.vue'

const { is: userIs } = useCurUser()
</script>

<style lang="scss" scoped>
.talkjs-container {
  width: 100%;
  height: 100%;
}
</style>
